import pt_BR from './pt_BR.json'
import en_US from './en_US.json'

export default {
    pt_BR,
    en_US,
}
